import React, { useContext, useEffect, useState } from 'react';
import { SafeAreaView, View } from 'react-native';
import styled from 'styled-components/native';
import { DataContext } from 'opidcore';

import { BasicText as Text, SmallLabel } from '../Styles';

const StyledTextInput = styled.TextInput`
    margin: 12px;
    padding: 5px;
    overflow: hidden;
    border-width: 1px;
    border-color: #aaaaaa;
    border-radius: 4px;
`;

const InputText = ({field, label = undefined, onChange = undefined, defaultValue = undefined, placeholder = undefined, as = undefined, style = undefined, outerStyle = {}, readOnly = false, disabled = false, multiline = false, password = false, flexDirection = "row"}) => {
    const boundMagic = useContext(DataContext);
    const [value, setValue] = useState(boundMagic.magicalGet(field, defaultValue));
    const [height, setHeight] = useState(40);

    useEffect(()=>{
        //initial setup for the boundMagic
        if(onChange != undefined){
            boundMagic.magicalState(field, (val)=>{
                //if we have a custom change event it will be called here once boundMagic has a new value
                onChange(boundMagic, field, val);
            });
        }
    },[boundMagic]);

    useEffect(()=>{
        doUpdate(boundMagic.magicalGet(field, defaultValue));
    }, [defaultValue]);

    useEffect(()=>{
        boundMagic.magicalSet(field, value);
    }, [value])

    const doUpdate = (val) =>{
        setValue(val);
    };

    const doSizeAdjust = (event) => {
        const newHeight =  Math.max(40, event.nativeEvent.contentSize.height);
        if(height != newHeight){
            setHeight( newHeight );
        }
    }

    const defaultStyle = {flex: 1, flexBasis: "auto", alignItems: "center", flexDirection: flexDirection};

    return <View style={[defaultStyle, outerStyle]}>
        {label == undefined? null : <SmallLabel>{label}</SmallLabel>}
        {readOnly == true? 
            <Text>{value}</Text> :
            <StyledTextInput 
                onChangeText={doUpdate}
                onContentSizeChange={doSizeAdjust}
                value={value}
                placeholder={placeholder}
                as={as}
                style={ [style, {height: height}] }
                multiline={multiline}
                editable={!disabled}
                secureTextEntry={password}
            />
        }
    </View>;
        
}

export default InputText;